// Zigbee-State-Map fuer /zuhause/integrationen/zigbee. Map device-id ->
// ZigbeeState. Backend: zigbee2mqtt + Last-Seen-Tracker. Die Daten liest nur
// die Navigationssuche (lib/inventory-index.svelte.ts): start* holt sie
// EINMAL (die Namen für Suche und Embedding-Index), danach Takt 30 s nur
// solange die Suche offen ist (beobachteZigbee, lib/bei-bedarf.ts).

import { untrack } from "svelte";
import { SvelteMap } from "svelte/reactivity";
import { beiBedarf } from "./bei-bedarf";
import { registerRevalidator } from "./revalidate.svelte";

import { loadPersisted, persist } from "./persistent-summary.svelte";
import type { ZigbeeStateMap } from "./types";

const STORAGE_KEY = "zigbee";

const _state = new SvelteMap<string, ZigbeeStateMap>();
let _started = false;

async function refresh(): Promise<void> {
  try {
    const r = await fetch("/v2-api/zigbee/state", { credentials: "include" });
    if (!r.ok) return;
    const map = (await r.json()) as ZigbeeStateMap;
    _state.set("current", map);
    persist(STORAGE_KEY, map);
  } catch {
    // ignore
  }
}

// frisch: die Navigationssuche wird beim Tippen und Leeren der Palette neu gebaut
// (beobachteInventar) -- ein Abruf, der jünger als 30 s ist, genügt.
const _bedarf = beiBedarf({ hole: refresh, takt: 30_000, frisch: 30_000 });

export function startZigbeeSummary(): void {
  if (_started) return;
  _started = true;
  registerRevalidator(() => {
    if (_bedarf.aktiv()) void refresh();
  });
  const cached = loadPersisted<ZigbeeStateMap>(STORAGE_KEY);
  if (cached) _state.set("current", cached);
  void refresh();
}

// Anmelden, solange die Suche die Geräte zeigt; der Rückgabewert meldet ab.
export function beobachteZigbee(): () => void {
  return untrack(() => {
    startZigbeeSummary();
    return _bedarf.beobachte();
  });
}

export function stopZigbeeSummary(): void {
  _started = false;
  _bedarf.beende();
  _state.clear();
}

export function getZigbeeSummary(): ZigbeeStateMap | undefined {
  return _state.get("current");
}

export async function refreshZigbeeSummary(): Promise<void> {
  await refresh();
}
